"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
// @ts-ignore
var logger_1 = require("$ice/logger");
var module = function (_a) {
    var appConfig = _a.appConfig;
    var _b = appConfig.logger, userLogger = _b === void 0 ? {} : _b;
    if (userLogger.level) {
        return logger_1.default.setLevel(userLogger.level);
    }
    var loglevel = process.env.NODE_ENV === 'development' ? 'DEBUG' : 'WARN';
    if (userLogger.smartLoglevel) {
        var searchParams = getSearchParams();
        if (searchParams.__loglevel__) {
            loglevel = searchParams.__loglevel__;
        }
    }
    logger_1.default.setLevel(loglevel);
};
function getSearchParams() {
    var searchParams = {};
    if (location.hash) {
        searchParams = queryString.parse(location.hash.substring(2));
    }
    else {
        searchParams = queryString.parse(location.search);
    }
    return searchParams;
}
exports.default = module;
